import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailSynopsisArrowLeftContainer = styled.div<React.CSSProperties>`
  cursor: pointer;
  position: fixed;
  left: ${96 * Screen.widthRatio}px;
  top: ${858 * Screen.widthRatio}px;
`;
export default DetailSynopsisArrowLeftContainer;
